import Firebase from "firebase/app";

let counter = 0;

export const getNewTransactionID = () => {
  const now = new Date().getTime();
  const start = new Date(2020, 0o1, 0o1, 0, 0, 0, 0).getTime();
  const timeBasedID = parseInt(((now - start) / 1000).toFixed(0));
  const transactionIDString = `${timeBasedID}${counter}`;

  // Increment counter and reset it after 9
  counter = (counter + 1) % 10;

  // Ensure we don't exceed the MySQL INT limit in PlanetScale when used for transaction_id. This will work until 2088, but we may need to change this to BIGINT.
  return parseInt(transactionIDString);
};

export function startCommand(chargePointId, command, payload) {
  return Firebase.firestore()
    .collection(`ocpp_logs/${chargePointId}/pending_commands`)
    .add({
      id: `${getNewTransactionID()}`,
      timestamp: new Date(),
      command: command,
      payload: payload,
      ocpi: false,
    })
    .then((doc) => doc.id)
    .catch((error) => {
      alert(`Unable to initiate command: ${error.message}`);
    });
}

export function cancelCommand(chargePointId, id) {
  let doc = Firebase.firestore()
    .collection(`ocpp_logs/${chargePointId}/pending_commands`)
    .doc(id)
    .delete();
}
